var _excluded = ["onClick", "onKeyDown", "onMouseEnter", "onMouseLeave", "type", "title", "tabIndex", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
var defaultProps = {
  type: "button"
};
var StyledButton = styled.button.withConfig({
  componentId: "sc-13jrjm-0"
})(["padding:0;border:0;background:none;cursor:pointer;"]);
function Button(_ref) {
  var onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? defaultProps.type : _ref$type,
    title = _ref.title,
    tabIndex = _ref.tabIndex,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    type: type,
    title: title,
    tabIndex: tabIndex
  }, restProps), children);
}
export default Button;